module.exports = __webpack_public_path__ + "img/minus.2d1e6c19.svg";